import React, { useState, useEffect } from "react";
import { NavLink, useNavigate, Outlet } from "react-router-dom";
import { getResidentData, logoutResident } from "../../helpers/residentauth";
// import Footer from "../Footer";
import { useSettings } from "../../context/SettingContext";

const ResidentLayout: React.FC = () => {
    // const navigate = useNavigate();
    const [sidebarOpen, setSidebarOpen] = useState(true);
    // લોગઆઉટ મોડલ માટેનું સ્ટેટ
    const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
    const residentData = getResidentData();
    const settings=useSettings()

    // Theme state
    const [theme, setTheme] = useState(() => localStorage.getItem("theme") || "light");

    useEffect(() => {
        document.documentElement.setAttribute("data-bs-theme", theme);
        document.documentElement.setAttribute("data-theme", theme);
        localStorage.setItem("theme", theme);
        
        // Add class to body for custom CSS if any
        if (theme === "dark") {
            document.body.classList.add("dark-theme");
        } else {
            document.body.classList.remove("dark-theme");
        }
    }, [theme]);

    const toggleTheme = () => setTheme(prev => (prev === "light" ? "dark" : "light"));

    const menuItems = [
        { path: "/resident/dashboard", icon: "ri-dashboard-line", label: "Dashboard" },
        { path: "/resident/bills", icon: "ri-bill-line", label: "My Bills" },
        { path: "/resident/payments", icon: "ri-wallet-line", label: "Payment History" },
          { path: "/resident/tenants", icon: "ri-team-line", label: "My Tenants" },
        { path: "/resident/profile", icon: "ri-user-line", label: "Profile" },
    ];

    const handleLogout = () => {
        logoutResident();
        setIsLogoutModalOpen(false);
  
    };

    return (
        <div style={{ display: "flex", minHeight: "100vh", background: theme === "dark" ? "#0f172a" : "#f7fafc", color: theme === "dark" ? "#e2e8f0" : "#1e293b", transition: "background 0.3s, color 0.3s" }}>
            {/* Sidebar */}
            <div style={{
                width: sidebarOpen ? "260px" : "70px",
                background: "radial-gradient(circle at 50% -20%, #1e293b, #0f172a, #070a12)",
                transition: "width 0.3s",
                color: "#fff",
                display: "flex",
                flexDirection: "column",
                position: "fixed",
                height: "100vh",
                zIndex: 100,
                boxShadow: "2px 0 10px rgba(0,0,0,0.1)", // ફિક્સ: rgba માં છેલ્લે 0.1 કર્યું
            }}>
                {/* Logo */}
                <div style={{
                    padding: "20px",
                    borderBottom: "1px solid rgba(255,255,255,0.1)",
                    textAlign: "center",
                }}>
                    {sidebarOpen ? (
                        <>
                            <i className="ri-building-2-line" style={{ fontSize: "32px" }} />
                            <h5 className="mb-0 mt-2 fw-bold">Owner Portal</h5>
                            <h6 className="mb-0 mt-2 "style={{fontSize:"12px"}}>{settings.site_name}</h6>
                           
                        </>
                    ) : (
                        <i className="ri-building-2-line" style={{ fontSize: "28px" }} />
                    )}
                </div>

                {/* User Info */}
                {sidebarOpen && residentData && (
                    <div style={{
                        padding: "16px 20px",
                        borderBottom: "1px solid rgba(255,255,255,0.1)",
                    }}>
                        <div className="d-flex align-items-center gap-2">
                            <div style={{
                                width: "40px", height: "40px", borderRadius: "50%",
                                background: "rgba(255,255,255,0.2)",
                                display: "flex", alignItems: "center", justifyContent: "center",
                                fontSize: "16px", fontWeight: 700,
                            }}>
                                {residentData.name?.charAt(0).toUpperCase()}
                            </div>
                            <div style={{ overflow: "hidden" }}>
                                <div className="fw-bold" style={{ fontSize: "14px" }}>
                                    {residentData.name}
                                </div>
                                <div style={{ fontSize: "12px", opacity: 0.8 }}>
                                    {residentData.unit?.unitNo}
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Menu */}
                <div style={{ flex: 1, padding: "16px 8px", overflowY: "auto" }}>
                    {menuItems.map(item => (
                        <NavLink key={item.path} to={item.path}
                            style={({ isActive }) => ({
                                display: "flex", alignItems: "center", gap: "12px",
                                padding: "12px 16px", marginBottom: "4px",
                                borderRadius: "10px", color: "#fff",
                                textDecoration: "none", fontSize: "14px", fontWeight: 500,
                                background: isActive ? "rgba(195, 181, 203, 0.2)" : "transparent",
                                transition: "all 0.2s",
                            })}
                        >
                            <i className={item.icon} style={{ fontSize: "20px" }} />
                            {sidebarOpen && <span>{item.label}</span>}
                        </NavLink>
                    ))}
                </div>

                {/* Logout Button */}
                <div style={{ padding: "16px", borderTop: "1px solid rgba(255,255,255,0.1)" }}>
                    <button onClick={() => setIsLogoutModalOpen(true)} // અહીં મોડલ ઓપન થશે
                        style={{
                            width: "100%", padding: "10px", borderRadius: "10px",
                            background: "rgba(220,53,69,0.2)", border: "1px solid rgba(220,53,69,0.4)",
                            color: "#fff", cursor: "pointer", fontWeight: 500,
                            display: "flex", alignItems: "center", justifyContent: "center", gap: "8px",
                        }}>
                        <i className="ri-logout-box-line" style={{ fontSize: "18px" }} />
                        {sidebarOpen && "Logout"}
                    </button>
                </div>
            </div>

            {/* Main Content */}
            <div style={{
                marginLeft: sidebarOpen ? "260px" : "70px",
                flex: 1,
                transition: "margin-left 0.3s",
            }}>
                {/* Top Bar */}
                <div style={{
                    background: theme === "dark" ? "#1e293b" : "#fff",
                    padding: "12px 24px",
                    boxShadow: theme === "dark" ? "0 2px 4px rgba(0,0,0,0.2)" : "0 2px 4px rgba(0,0,0,0.04)",
                    display: "flex", alignItems: "center", justifyContent: "space-between",
                    position: "sticky", top: 0, zIndex: 50,
                    transition: "background 0.3s, box-shadow 0.3s"
                }}>
                    <button onClick={() => setSidebarOpen(!sidebarOpen)}
                        style={{
                            background: theme === "dark" ? "#334155" : "#f1f5f9", 
                            color: theme === "dark" ? "#e2e8f0" : "inherit",
                            border: "none", borderRadius: "8px",
                            padding: "8px 12px", cursor: "pointer", fontSize: "18px",
                            transition: "background 0.3s, color 0.3s"
                        }}>
                        <i className="ri-menu-line" />
                    </button>

                    <div className="d-flex align-items-center gap-3">
                        {/* Theme Toggle Button */}
                        <button 
                            onClick={toggleTheme}
                            style={{
                                background: theme === "dark" ? "#334155" : "#f1f5f9",
                                border: "none", borderRadius: "50%",
                                width: "36px", height: "36px", display: "flex", 
                                alignItems: "center", justifyContent: "center",
                                cursor: "pointer", fontSize: "18px",
                                color: theme === "dark" ? "#fbbf24" : "#64748b",
                                transition: "all 0.3s"
                            }}
                            title={`Switch to ${theme === "light" ? "Dark" : "Light"} Mode`}
                        >
                            <i className={theme === "light" ? "ri-moon-line" : "ri-sun-fill"} />
                        </button>

                        <div className="d-flex align-items-center gap-2">
                            <div style={{
                                width: "36px", height: "36px", borderRadius: "50%",
                                background: "linear-gradient(135deg, #667eea, #764ba2)",
                                display: "flex", alignItems: "center", justifyContent: "center",
                                color: "#fff", fontWeight: 700, fontSize: "14px",
                            }}>
                                {residentData?.name?.charAt(0).toUpperCase()}
                            </div>
                            <div className="d-none d-md-block">
                                <div className="fw-bold" style={{ fontSize: "13px", lineHeight: 1.2, color: theme === "dark" ? "#f8fafc" : "inherit" }}>
                                    {residentData?.name}
                                </div>
                                <div style={{ fontSize: "11px", color: theme === "dark" ? "#cbd5e1" : "#6c757d" }}>
                                    {residentData?.unit?.unitNo}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Page Content */}
                <div style={{ padding: "24px" }}>
                    <Outlet />
                </div>
                {/* <Footer /> */}
            </div>

            {/* CUSTOM LOGOUT CONFIRMATION MODAL */}
            {isLogoutModalOpen && (
                <div style={{
                    position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
                    backgroundColor: "rgba(0, 0, 0, 0.5)", display: "flex",
                    alignItems: "center", justifyContent: "center", zIndex: 1000,
                    backdropFilter: "blur(4px)" // પાછળનું બેકગ્રાઉન્ડ બ્લર કરવા માટે
                }}>
                    <div style={{
                        background: "#fff", padding: "30px", borderRadius: "16px",
                        width: "90%", maxWidth: "400px", textAlign: "center",
                        boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
                        animation: "fadeIn 0.2s ease"
                    }}>
                        {/* મોડલ આઇકોન */}
                        <div style={{
                            width: "60px", height: "60px", borderRadius: "50%",
                            background: "#fef2f2", color: "#dc3545", display: "flex",
                            alignItems: "center", justifyContent: "center", margin: "0 auto 16px",
                            fontSize: "28px"
                        }}>
                            <i className="ri-error-warning-line" />
                        </div>

                        <h4 style={{ margin: "0 0 8px 0", fontWeight: "700", color: "#1e293b" }}>
                            Confirm Logout
                        </h4>
                        <p style={{ margin: "0 0 24px 0", color: "#64748b", fontSize: "14px" }}>
                            Are you sure you want to log out of your account?
                        </p>

                        {/* બટન્સ */}
                        <div style={{ display: "flex", gap: "12px", justifyContent: "center" }}>
                            <button 
                                onClick={() => setIsLogoutModalOpen(false)}
                                style={{
                                    flex: 1, padding: "12px", borderRadius: "10px",
                                    border: "1px solid #cbd5e1", background: "#fff",
                                    color: "#64748b", fontWeight: "600", cursor: "pointer",
                                    transition: "background 0.2s"
                                }}
                            >
                                Cancel
                            </button>
                            <button 
                                onClick={handleLogout}
                                style={{
                                    flex: 1, padding: "12px", borderRadius: "10px",
                                    border: "none", background: "#dc3545",
                                    color: "#fff", fontWeight: "600", cursor: "pointer",
                                    boxShadow: "0 4px 6px -1px rgba(220, 53, 69, 0.2)",
                                    transition: "background 0.2s"
                                }}
                            >
                                Yes, Logout
                            </button>
                        </div>
                    </div>
                </div>
            )}
            
        </div>
    );
};

export default ResidentLayout;